import { IQuery, IQueryMediator } from 'core-ts-types';
import { ITimeOccurrenceDatatype } from '../datastore/time/data_types';
import { TimeOccurrenceDataSource } from '../datastore/time/time_datasource';

export class OrderedTimeQueryModel implements IQuery {
  public model: ITimeOccurrenceDatatype[];

  constructor(private ngTimeOccurrenceDataSource: TimeOccurrenceDataSource, QueryMediator: IQueryMediator) {
    QueryMediator.registerQuery(this, ngTimeOccurrenceDataSource);
    this.model = [];
  }

  run(): this {
    this.model = _(this.ngTimeOccurrenceDataSource.store).sortBy('fromInput').sortBy('day.ordinal').value();
    return this;
  }

  getTimes(): ITimeOccurrenceDatatype[] {
    return this.model;
  }

  get result(): ITimeOccurrenceDatatype[] {
    return this.model;
  }
}

angular
  .module('ui-ng-calendar')
  .factory(
    'ngOrderedTimeQueryModel',
    function (ngTimeOccurrenceDataSource: TimeOccurrenceDataSource, QueryMediator: IQueryMediator) {
      return new OrderedTimeQueryModel(ngTimeOccurrenceDataSource, QueryMediator);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/query_models/ordered_time_query_model.ts